export enum ENUM_TASK_STATUS {
  ALL = 'all',
  RESOLVED = 'resolved',
  UNRESOLVED = 'pending'
}

export const taskStatusList = [
  { value: ENUM_TASK_STATUS.ALL, name: 'All' },
  { value: ENUM_TASK_STATUS.RESOLVED, name: 'Resolved' },
  { value: ENUM_TASK_STATUS.UNRESOLVED, name: 'Pending' }
];

export enum ENUM_SEARCH_TYPE {
  REP_NAME = 'full_name',
  ORDER_CODE = 'order_code',
  USER_NAME = 'full_name',
  TASK = 'task'
}
